import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';

import { isValidNumber } from '../../helpers/Util';
import format from '../../helpers/NumberFormatter';
import NumberFormat from '../../enums/NumberFormat';

const renderMarkdownLinks = text => {
    if (typeof text !== 'string') {
        return text !== undefined && text !== null ? String(text) : '';
    }

    const Link = ({ node, ...props }) => {
        const href = props.href || '';
        const isValidUrl = /^https?:\/\//i.test(href) || href.startsWith('/');
        if (!isValidUrl) {
            return props.children;
        }
        return <a {...props} target="_blank" rel="noopener noreferrer" />;
    };

    return (
        <ReactMarkdown
            source={text}
            allowedTypes={['link', 'text']}
            unwrapDisallowed
            renderers={{
                link: Link,
            }}
            linkTarget="_blank"
        >
            {text}
        </ReactMarkdown>
    );
};

/**
 * @param {object} param0
 * @param {object} param0.featureProperties
 * @param {string} [param0.titleColumn]
 * @param {import('../../types').UserDataInteractivityDataColumn[]} param0.dataColumns
 * @param {boolean} param0.isClickMode
 */
const InfoBubbleUserData = ({ featureProperties, titleColumn, dataColumns, isClickMode }) => {
    if (!titleColumn && !dataColumns.length) {
        // If no title or content is selected display the message!
        return (
            <div
                className={classNames('user-data-popup--empty', {
                    'user-data-popup--empty-click-mode': isClickMode,
                })}
            >
                Use interactivity settings to customize popup.
            </div>
        );
    }

    const rows = dataColumns.map(column => (
        <div className="user-data-popup__row" key={column}>
            <span className="user-data-popup__row-title wrap">{column}</span>
            <span className="user-data-popup__row-value text-right wrap">
                {isValidNumber(featureProperties[column])
                    ? format({
                          number: featureProperties[column],
                          numberFormat: NumberFormat.FORMAT_NUMBER_2_DECIMAL,
                      })
                    : renderMarkdownLinks(featureProperties[column])}
            </span>
        </div>
    ));

    const classes = classNames('user-data-popup', {
        'user-data-popup--with-content-column': dataColumns.length,
        'user-data-popup--click-mode-no-title': isClickMode && !titleColumn,
    });

    return (
        <div className={classes}>
            {titleColumn && (
                <h5
                    className={classNames('user-data-popup__title', {
                        'user-data-popup--title-click-mode': isClickMode,
                    })}
                >
                    {renderMarkdownLinks(featureProperties[titleColumn])}
                </h5>
            )}
            {!!rows.length && <div className="user-data-popup__rows">{rows}</div>}
        </div>
    );
};

InfoBubbleUserData.propTypes = {
    featureProperties: PropTypes.object.isRequired,
    dataColumns: PropTypes.array,
    titleColumn: PropTypes.string,
    isClickMode: PropTypes.bool.isRequired,
};

InfoBubbleUserData.defaultProps = {
    dataColumns: [],
    titleColumn: undefined,
};

export default InfoBubbleUserData;
